import notificationActions from "actions/notification";
import { ChatsList } from "components/chats/list";
import { connect, generatedActions, tableDispatchToProps, tableStateToProps } from "helpers/redux";

export { chatTypes, chatTypesEnum } from "helpers/enums";

export default connect(
    (state) => tableStateToProps(state, "notifications"),
    (dispatch) => ({
        toggleFavorite: (params) => dispatch(notificationActions.toggleFavorite(params)),
        ...tableDispatchToProps(dispatch, generatedActions.notifications),
    }),
)(ChatsList);
